<template>
  <a :href="href">
    <b-icon icon="email-outline" size="is-small" />
    {{ displayEmail }}
  </a>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { BIcon } from 'buefy'

const props = defineProps<{
  user: string
  domain: string
  subject?: string
}>()

const email = computed(() => `${props.user}@${props.domain}`)

const displayEmail = computed(() => email.value.replace('@', '[AT]').replace(/\./g, '[DOT]'))

const href = computed(() => {
  const base = `mailto:${email.value}`
  return props.subject ? `${base}?subject=${encodeURIComponent(props.subject)}` : base
})
</script>
